// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"_2Fn8Do","customButton":"_3GUA-E","active":"_3mjogV"};